import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 bg-white add-user-card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "text-black fw-semibold" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "row gx-3" }
const _hoisted_6 = { class: "col-md-12 mb-3" }
const _hoisted_7 = { class: "alert alert-info" }
const _hoisted_8 = { class: "mb-0" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-6 mb-3" }
const _hoisted_11 = { class: "col-md-3 mb-3" }
const _hoisted_12 = { class: "input-group" }
const _hoisted_13 = { class: "input-group-text" }
const _hoisted_14 = { class: "col-md-12" }
const _hoisted_15 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, "Compléter un conditionnement pour " + _toDisplayString(_ctx.produit?.nomProd), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.addProduitConditionnement,
        "validation-schema": _ctx.conditionnementSchema
      }, {
        default: _withCtx(({ errors }) => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, [
                  _cache[0] || (_cache[0] = _createTextVNode(" Ajout de conditionnement pour le produit : ")),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.produit?.codeProduit) + " - " + _toDisplayString(_ctx.produit?.nomProd), 1),
                  _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                  _cache[2] || (_cache[2] = _createTextVNode(" Unité de gestion actuelle : ")),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.uniteGestionLabel), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                  _createTextVNode(" Conditionnement "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "conditionnement",
                  type: "text"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.conditionnementOptions,
                      searchable: true,
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      "track-by": "label",
                      label: "label",
                      placeholder: "Sélectionner un conditionnement"
                    }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "conditionnement",
                  class: "text-danger"
                })
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                  _createTextVNode(" Quantité "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_Field, {
                    name: "quantite",
                    type: "number",
                    class: "form-control shadow-none fs-md-15 text-black",
                    min: "0"
                  }),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.uniteGestionLabel || 'UM'), 1)
                ]),
                _createVNode(_component_ErrorMessage, {
                  name: "quantite",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[6] || (_cache[6] = _createElementVNode("button", {
                  class: "btn btn-success me-3",
                  type: "submit"
                }, " Ajouter le conditionnement(s) ", -1)),
                _createVNode(_component_router_link, {
                  to: { name: 'ViewProduit', params: { id: _ctx.produit?.id } },
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createElementVNode("i", { class: "fa fa-times me-1" }, null, -1),
                    _createTextVNode(" Annuler ")
                  ])),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}